// ===========================================
// HOOK: useAlertaVencimientoForm (ORR-232)
// ===========================================
// Hook TanStack Form para programar una alerta de vencimiento

import { useForm } from '@tanstack/react-form'
import { alertaVencimientoSchema, type AlertaVencimientoFormValues } from './alertaVencimientoSchema'

interface UseAlertaVencimientoFormOptions {
  onSubmit?: (value: AlertaVencimientoFormValues) => Promise<void>
  defaultValues?: Partial<AlertaVencimientoFormValues>
}

export function useAlertaVencimientoForm(options: UseAlertaVencimientoFormOptions = {}) {
  const form = useForm({
    defaultValues: {
      dias_antes: 3,
      alcance: 'solo_proximo',
      ...options.defaultValues,
    } as AlertaVencimientoFormValues,
    validators: {
      onSubmit: alertaVencimientoSchema,
    },
    onSubmit: async ({ value }) => {
      if (options.onSubmit) {
        await options.onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseAlertaVencimientoFormReturn = ReturnType<typeof useAlertaVencimientoForm>
export type AlertaVencimientoForm = UseAlertaVencimientoFormReturn['form']
